import { Group, Path, Point, Segment } from "paper";
import { addEdgeLipsReversed, addMarkers, breakPath, mirrorX, removeLastSegment, setDefaultStyle, smoothCorner } from "../draw";
import { markerSpacing, P, Segments } from "./common";
export class ConicalFlask {
    render(appearance) {
        let { graphic, markers, neckWidth, neckHeight } = baseFlaskGraphic(appearance);
        addEdgeLipsReversed(graphic);
        let liquidMask = graphic.clone();
        setDefaultStyle(graphic);
        let graphicWithMarkers = new Group([graphic, markers]);
        return {
            graphic: graphicWithMarkers,
            hitShape: graphic.bounds.toShape(),
            liquidMaskOpening: { start: P(-neckWidth / 2, -neckHeight), end: P(neckWidth / 2, -neckHeight) },
            liquidMask: liquidMask,
            snapping: [
                graphic.placeable(),
                { type: "neck", top: P(0, -neckHeight), diameter: neckWidth, facing: 0 },
            ]
        };
    }
}
// Based on: https://www.amazon.co.uk/dp/B07CQNWN4C/ref=twister_B07CQ1ZX9L?_encoding=UTF8&th=1
ConicalFlask.properties = {
    label: "Conical flask",
    canContainLiquids: true,
    meniscus: true,
    pourable: true,
    defaultAppearance: {
        size: 100,
    },
    appearanceSpecs: [{
            spec: "slider", key: "size", label: "Size",
            min: 80, max: 200,
        }]
};
export class ConicalFlaskWithSideArm {
    render(appearance) {
        let holeRadius = 5;
        let sideArmLength = 15;
        let offset = -17;
        let { graphic, markers, neckWidth, neckHeight } = baseFlaskGraphic(appearance, 35);
        // Insert the spout
        graphic.insertSegments(1, Segments([[neckWidth / 2, offset - holeRadius]], [[neckWidth / 2 + sideArmLength, offset - holeRadius]], [[neckWidth / 2 + sideArmLength, offset + holeRadius]], [[neckWidth / 2, offset + holeRadius]]));
        addEdgeLipsReversed(graphic);
        let liquidMask = graphic.clone();
        let parts = breakPath(graphic, 4);
        setDefaultStyle(parts);
        let graphicWithMarkers = new Group([parts, markers]);
        return {
            graphic: graphicWithMarkers,
            hitShape: graphic.bounds.toShape(),
            liquidMask: liquidMask,
            snapping: [
                graphic.placeable(),
                { type: "connectable", at: P(neckWidth / 2 + sideArmLength, offset), facing: 90 },
                { type: "neck", top: P(0, -neckHeight), diameter: neckWidth, facing: 0 },
            ]
        };
    }
}
ConicalFlaskWithSideArm.properties = {
    label: "Conical flask with side arm",
    canContainLiquids: true,
    flippable: true,
    defaultAppearance: ConicalFlask.properties.defaultAppearance,
    appearanceSpecs: ConicalFlask.properties.appearanceSpecs,
};
function baseFlaskGraphic(appearance, minNeckHeight = 0) {
    let ratio = appearance.size / 150;
    let neckHeight = Math.max(minNeckHeight, 40 * ratio);
    let neckWidth = 20 + Math.sqrt(ratio) * 20;
    let baseHeight = 150 * ratio;
    let baseWidth = 145 * ratio;
    let corner = 10.0 + ratio * 20;
    let graphic = new Path();
    graphic.addSegments([
        // Neck.
        new Segment(new Point(neckWidth / 2, -neckHeight)),
        new Segment(new Point(neckWidth / 2, 0)),
        // Base
        new Segment(new Point(baseWidth / 2, baseHeight)),
        new Segment(new Point(0, baseHeight))
    ]);
    smoothCorner(graphic.segments[2], corner);
    removeLastSegment(graphic);
    mirrorX(graphic, 0);
    // Create markers.
    var markers = new Group();
    var bottomRightCorner = new Point((baseWidth - neckWidth) / 2 - 3.0, baseHeight);
    let scaleRatio = bottomRightCorner.y / markerSpacing;
    let markSpacingVector = bottomRightCorner.divide(scaleRatio);
    let markStart = bottomRightCorner.add([neckWidth / 2 - 7.0, 0]);
    addMarkers(markers, markStart, 0, markSpacingVector);
    return { graphic: graphic, markers: markers, neckWidth, neckHeight };
}
